import { schema } from 'normalizr';

export const ProductClpSchema = new schema.Entity('productClps', {}, { idAttribute: 'ProductId' });
